import category from "./category";
import source from "./source";
export default {
	category,
	source
}